var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBsTimelines = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 22,
  viewBox: "0 0 30 22",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M28.556 18c.798 0 1.444.894 1.444 2s-.646 2-1.444 2H5.444C4.646 22 4 21.106 4 20s.646-2 1.444-2Zm-3.89-6c.738 0 1.334.894 1.334 2s-.596 2-1.333 2H11.333C10.596 16 10 15.106 10 14s.596-2 1.333-2ZM6 12c1.106 0 2 .894 2 2s-.894 2-2 2H2c-1.106 0-2-.894-2-2s.894-2 2-2Zm22.556-6C29.354 6 30 6.894 30 8s-.646 2-1.444 2H5.444C4.646 10 4 9.106 4 8s.646-2 1.444-2Zm-13.89-6C15.405 0 16 .894 16 2s-.596 2-1.333 2H1.333C.596 4 0 3.106 0 2s.596-2 1.333-2ZM24 0c1.106 0 2 .894 2 2s-.894 2-2 2h-4c-1.106 0-2-.894-2-2s.894-2 2-2Z"
})));
export default SvgBsTimelines;